import { z } from "zod";
import { LeaseCompPropertyType } from "../interfaces/ILeaseComp";

export default () => z.object({
    address: z.string().min(1),
    pipedriveCompanyName: z.string().min(1),
    totalRent: z.number().positive(),
    signedDate: z.date(),
    year: z.number().positive().int().nullable(),
    ti: z.number().nonnegative().nullable(),
    escalations: z.string().refine((val) => !/-\d/.test(val), "String cannot contain negative numbers").nullable(),
    tenantLandSize: z.number().nonnegative().nullable(),
    parcelSizeAcres: z.number().positive(),
    buildingSize: z.number().nonnegative(),
    propertyType: z.string().min(1),
    compSource: z.string().min(1),
}).refine((values) => !!values.tenantLandSize || values.propertyType === LeaseCompPropertyType.SmallBay, {
    message: "Zero or blank is allowed only for Small Bay property type",
    path: ["tenantLandSize"],
});